import React from 'react';
import { ArrowRight, Shield } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const stats = [
  { icon: Shield, value: '7+', label: 'stats.experience' },
];

export function Hero() {
  const { t } = useLanguage();

  return (
    <div className="relative bg-blue-900">
      <div className="absolute inset-0">
        <img
          className="w-full h-full object-cover opacity-20"
          src="https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&q=80"
          alt="Professional cleaning"
        />
      </div>
      <div className="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
            {t('hero.title')}
          </h1>
          <p className="mt-6 text-xl text-gray-300 max-w-3xl mx-auto">
            {t('hero.subtitle')}
          </p>
          <div className="mt-10 flex justify-center">
            <a
              href="/contact"
              className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-blue-900 bg-white hover:bg-gray-50 transition-colors"
            >
              {t('hero.requestQuote')}
              <ArrowRight className="ml-2 h-5 w-5" />
            </a>
          </div>
        </div>

        <div className="mt-20">
          <dl className="grid grid-cols-1 gap-8 sm:grid-cols-1 sm:place-items-center">
            {stats.map(({ icon: Icon, value, label }) => (
              <div key={label} className="text-center">
                <Icon className="mx-auto h-12 w-12 text-white/80" />
                <dt className="mt-4 text-3xl font-extrabold text-white">{value}</dt>
                <dd className="mt-2 text-gray-300">{t(label)}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}